import styled from "@emotion/styled";

import type { ConditionViewComponentProps } from "../../../types/index.ts";
import { ExpressionForm } from "../../../values/forms/index.ts";
import type { ValueExpressionConditionContext } from "./valueExpressionConditionBuilder.tsx";

/**
 * The config is a whole ValueExpression, so editing it is the generic form's job.
 * No scope or exclusion is given: belonging to no node, the condition takes the
 * trigger's own scope and has no values of its own to leave out of the offer.
 */
export const ValueExpressionConditionEditor = ({
  config,
  onConfigChange,
}: ConditionViewComponentProps<ValueExpressionConditionContext>) => (
  <FormContainer>
    <ExpressionForm expression={config} onChange={onConfigChange} bindable dataTest="value-expression-condition-form" />
  </FormContainer>
);

const FormContainer = styled.div`
  width: 320px;
`;
